import { QBankStructureCreationModalActionProvider } from '@exam-management/qbank-structure-creation';
import { Outlet } from 'react-router-dom';

export default function QBankStructureListLayout() {
  return (
    <QBankStructureCreationModalActionProvider>
      <Outlet />
    </QBankStructureCreationModalActionProvider>
  );
}
